import { Markierung } from '@/domain/mitarbeiter/features/rotationsplan/entities/Markierung';
import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';
import { KalenderByArbeitsbereicheStation } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/kalenderByArbeitsbereiche/KalenderStation';
import {
  getColorsForMarkierung,
  getTextColorForBackground,
} from '@/domain/mitarbeiter/features/rotationsplan/utils/getColorForMarkierung';

export class KalenderArbeitsbereich {
  constructor({
    markierung,
    name,
    stationen,
    id,
    standort,
  }: {
    markierung: Markierung;
    name: string;
    stationen?: KalenderByArbeitsbereicheStation[];
    id: string;
    standort: Standort;
  }) {
    this.markierung = markierung;
    this.name = name;
    this.stationen = stationen;
    this.id = id;
    this.standort = standort;
  }

  id: string;
  standort: Standort;
  markierung: Markierung;
  name: string;
  stationen?: KalenderByArbeitsbereicheStation[];

  getFillColor(): string {
    return getColorsForMarkierung(this.markierung).light;
  }

  getBorderColor(): string {
    return getColorsForMarkierung(this.markierung).base;
  }

  getTextColor(): string {
    return getTextColorForBackground(this.getBorderColor());
  }
}
